import { z } from 'zod';

export interface SupportTicketMessage {
  readonly id: string;
  readonly ticketId: string;
  readonly senderId: string | null;
  readonly senderName: string | null;
  readonly body: string;
  readonly createdAt: string;
  /** Admin-only note (RLS hides these rows from the ticket creator entirely —
   * see 20260722110000_phase10_ticketing_enhancements.sql). */
  readonly isInternal: boolean;
}

const rowSchema = z.object({
  id: z.string(),
  ticket_id: z.string(),
  sender_id: z.string().nullable(),
  body: z.string(),
  created_at: z.string(),
  is_internal: z.boolean(),
  sender: z.object({ full_name: z.string() }).nullable().optional(),
});

export function mapSupportTicketMessage(row: unknown): SupportTicketMessage {
  const r = rowSchema.parse(row);
  return {
    id: r.id,
    ticketId: r.ticket_id,
    senderId: r.sender_id,
    senderName: r.sender?.full_name ?? null,
    body: r.body,
    createdAt: r.created_at,
    isInternal: r.is_internal,
  };
}
